import React from 'react';
import PropTypes from 'prop-types';
const uuid = require('uuid');

const AnalyticsActions = require('../../actions/AnalyticsActions');
const AnalyticsStore = require('../../stores/AnalyticsStore');
import ShortCourseStatsChart from './ShortCourseStatsChart';

const propTypes = {
    channelId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    shortCourseId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

const defaultProps = {};

class ShortCourseStatsChartChannel extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            analyticsStoreState: AnalyticsStore.getState(),
            getStatsActionId: null
        };

        this.getShortCourseStatsData = this.getShortCourseStatsData.bind(this);
        this.unsubscribes = [AnalyticsStore.listen(this.onAnalyticsStoreChange.bind(this))];
    }

    componentDidMount() {
        if (!this.state.analyticsStoreState.shortCourseStats[this.props.shortCourseId]) {
            this.getShortCourseStatsData(this.props.channelId, this.props.shortCourseId);
        }
    }

    componentDidUpdate(prevProps) {
        if (
            prevProps.shortCourseId !== this.props.shortCourseId
            && !this.state.analyticsStoreState.shortCourseStats[this.props.shortCourseId]
        ) {
            this.getShortCourseStatsData(this.props.channelId, this.props.shortCourseId);
        }
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }

    getShortCourseStatsData(channelId, shortCourseId) {
        const actionId = uuid.v4();
        this.setState({ getStatsActionId: actionId }, () => {
            AnalyticsActions.getShortCourseStatsChannel(
                actionId,
                {
                    shortCourseId: shortCourseId,
                    channelId: channelId
                }
            );
        });
    }

    onAnalyticsStoreChange(state) {
        let additionalState = {};
        if (state.action.id === this.state.getStatsActionId) {
            additionalState = { ...additionalState, getStatsActionId: null };
        }

        this.setState({ analyticsStoreState: state, ...additionalState });
    }

    render() {
        const shortCourseStats = this.state.analyticsStoreState.shortCourseStats[this.props.shortCourseId];
        if (!shortCourseStats) {
            return null;
        }

        return (
            <ShortCourseStatsChart
                className="text-centered"
                avgTimePlayed={shortCourseStats.avgTimePlayed}
                totalCompleted={shortCourseStats.totalCompleted}
                timePlayedGraphData={shortCourseStats.timePlayedGraphData}
                completionGraphData={shortCourseStats.completionGraphData}
            />
        );
    }
}

ShortCourseStatsChartChannel.propTypes = propTypes;
ShortCourseStatsChartChannel.defaultProps = defaultProps;

export default ShortCourseStatsChartChannel;